import React, {useEffect, useState} from 'react';
import {Trans} from 'react-i18next';
import {Tab, Tabs} from 'react-bootstrap';
import {Link} from 'react-router-dom';

export default function AddSkincareTabSec() {
  const [tab, setTab] = useState('L');
  const url = window.location.href;

  useEffect(() => {
    const page = url.toString().split('/').pop();
    let tabKey;

    switch (page) {
      case 'skincare-product':
        tabKey = 'L';
        break;
      case 'skincare-routine':
        tabKey = 'R';
        break;
      case 'skincare-treatment':
        tabKey = 'S';
        break;
      default:
        tabKey = 'L';
    }

    handleChange(tabKey);
  }, [url]);

  const handleChange = e => {
    setTab(e);
  };

  const tabConfig = [
    {
      key: 'L',
      path: '/skincare-pro/add-skincare/skincare-product',
      title: (
        <Trans i18nKey="p.s.addskincare.tabs.skincareproduct">
          Skincare Product
        </Trans>
      ),
    },
    {
      key: 'R',
      path: '/skincare-pro/add-skincare/skincare-routine',
      title: (
        <Trans i18nKey="p.s.addskincare.tabs.skincareroutine">
          Skincare Routine
        </Trans>
      ),
    },
    {
      key: 'S',
      path: '/skincare-pro/add-skincare/skincare-treatment',
      title: (
        <Trans i18nKey="p.s.addskincare.tabs.skincaretreatment">
          Skincare Treatment
        </Trans>
      ),
    },
  ];

  return (
    <>
      <Tabs
        id="add-skincare-config"
        className="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand"
        defaultActiveKey="L"
        activeKey={tab}
        unmountOnExit={true}
        style={{margin: 0}}
      >
        {tabConfig.map(config => (
          <Tab
            key={config.key}
            className="nav-link"
            eventKey={config.key}
            title={
              <Link
                onClick={e => {
                  e.stopPropagation();
                }}
                to={config.path}
                style={{
                  padding: '12px 0 ',
                  color: tab === config.key ? '#5d78ff' : 'inherit',
                }}
              >
                {config.title}
              </Link>
            }
          />
        ))}
      </Tabs>
    </>
  );
}
